// Handle navigation transitions for mobile
export function setupNavigationTransitions() {
  // Only apply on mobile
  if (window.innerWidth > 768) return;
  
  // Add transition class based on navigation direction
  document.addEventListener('astro:before-preparation', (e: any) => {
    const from = e.from.pathname;
    const to = e.to.pathname;
    
    // Remove existing transition classes
    document.documentElement.classList.remove('from-discover', 'to-discover');
    
    // Going from discover to artist page
    if (from === '/discover' && to.includes('/artists/')) {
      document.documentElement.classList.add('from-discover');
    }
    
    // Going from artist page to discover
    if (from.includes('/artists/') && to === '/discover') {
      document.documentElement.classList.add('to-discover');
    }
  });
}